export default __webpack_public_path__ + "static/media/783.d8e7ce20.png";